import { Logo } from '@/shared/components/logo';
import GroupIllustration from '../assets/group-illustration.svg';
import { Outlet } from 'react-router-dom';
import { HelpMenu } from '@/shared/components/help-menu';

export function GroupLayout() {
  return (
    <main className="bg-white dark:bg-gray-900">
      <div className="relative md:flex">
        {/* Content */}
        <div className="md:w-1/2">
          <div className="min-h-dvh h-full flex flex-col after:flex-1">
            {/* Header */}
            <div className="flex-1">
              <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
                <Logo />
                <HelpMenu />
              </div>
            </div>

            <Outlet />
          </div>
        </div>

        {/* Image */}
        <div
          className="hidden md:flex absolute top-0 bottom-0 right-0 md:w-1/2 items-center justify-center"
          aria-hidden="true"
        >
          <img className="object-contain" src={GroupIllustration} width="760" height="1024" alt="Group Illustration" />
        </div>
      </div>
    </main>
  );
}
